import * as React from 'react'
import { translate } from 'react-translate'
import { FeesContainer } from './FeesContainer'

const componentStyle = {
  marginBottom: '50px',
  marginTop: '10px',
  width: '520px'
}

class SettingsFeesApp extends React.Component<any, any> {

  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

  }

  public render() {
    let t = this.props.t
    return (
      <div style={componentStyle} >
        {(this.props.showEdit) ? (
          <FeesContainer
            accountId={this.props.accountId}
            marketplaceId={this.props.marketplaceId}
            feeView="client"
            key="clientFeesView"
            header={t('CLIENT_FEES_HEADER')}
            containerStyle={{ marginBottom: '60px' }}
          />) : (null)}
        <FeesContainer
          accountId={this.props.accountId}
          marketplaceId={this.props.marketplaceId}
          readOnly={true}
          feeView="account"
          key="myAccountFeesView"
          header={t('ACCOUNT_FEES_HEADER')}
        />

        <div style={{ marginTop: '-10px' }}>
          <fieldset>
            <h3>{t('WITHDRAWAL_HEADER')}</h3>
            <section className="settings-block storage-fees">
              <div className="help-section bc-form">
                <textarea value={t('WITHDRAWAL_TEXTAREA')} disabled></textarea>
              </div>
            </section>
          </fieldset>
        </div>
      </div>
    )
  }
}
export default translate('SettingsFeesApp')(SettingsFeesApp)



// WEBPACK FOOTER //
// ./react/components/containers/SettingsFeeApp.tsx